export default __webpack_public_path__ + "static/3_30-b1832918e4f0c8b165b88ac4bbf3f232.png";